import React from 'react';

const GrabIcon = ({ width = 24, height = 24, color = '#000' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.1808 4C20.3508 4 19.6808 4.67 19.6808 5.5V10.5C19.6808 10.78 19.4608 11 19.1808 11C18.9008 11 18.6808 10.78 18.6808 10.5V2.5C18.6808 1.67 18.0108 1 17.1808 1C16.3508 1 15.6808 1.67 15.6808 2.5V10.5C15.6808 10.78 15.4608 11 15.1808 11C14.9008 11 14.6808 10.78 14.6808 10.5V1.5C14.6808 0.67 14.0108 0 13.1808 0C12.3508 0 11.6808 0.67 11.6808 1.5V10.49C11.6808 10.77 11.4608 10.99 11.1808 10.99C10.9008 10.99 10.6808 10.77 10.6808 10.49V4.5C10.6808 3.67 10.0108 3 9.18078 3C8.35078 3 7.68078 3.67 7.68078 4.5V15.91L3.56078 13.56C2.98078 13.23 2.26078 13.32 1.78078 13.78C1.18078 14.36 1.16078 15.32 1.75078 15.91L8.53078 22.8C9.28078 23.57 10.3008 24 11.3808 24H18.6808C20.8908 24 22.6808 22.21 22.6808 20V5.5C22.6808 4.67 22.0108 4 21.1808 4Z"
      fill={color}
    />
  </svg>
);

export default GrabIcon;
